export default __webpack_public_path__ + "static/media/gallery_05.8c32be16.jpg";